import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import {
  CheckCircle as CheckCircleIcon,
  Error as ErrorIcon,
  Info as InfoIcon,
  Close as CloseIcon,
  Warning as WarningIcon,
} from '@material-ui/icons';
import { green, amber } from '@material-ui/core/colors';
import { IconButton, SnackbarContent } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import { MessageTypes } from '../../constants';

const variantIcon = {
  [MessageTypes.ERROR]: ErrorIcon,
  [MessageTypes.WARNING]: WarningIcon,
  [MessageTypes.INFO]: InfoIcon,
  [MessageTypes.SUCCESS]: CheckCircleIcon,
};

const styles = theme => ({
  [MessageTypes.ERROR]: {
    backgroundColor: theme.palette.error.dark,
  },
  [MessageTypes.WARNING]: {
    backgroundColor: amber[700],
  },
  [MessageTypes.INFO]: {
    backgroundColor: theme.palette.primary.main,
  },
  [MessageTypes.SUCCESS]: {
    backgroundColor: green[600],
  },
  icon: {
    fontSize: 20,
  },
  iconVariant: {
    opacity: 0.9,
    marginRight: theme.spacing.unit,
  },
  message: {
    display: 'flex',
    alignItems: 'center',
  },
});

class Message extends React.Component {
  render() {
    const { onClose, message, variant, classes } = this.props;
    const Icon = variantIcon[variant];

    return (
      <SnackbarContent
        className={classes[variant]}
        aria-describedby="message"
        message={
          <span id="message" className={classes.message}>
            <Icon className={classNames(classes.icon, classes.iconVariant)} />
            {message}
          </span>
        }
        action={[
          <IconButton key="close" aria-label="Close" color="inherit" onClick={onClose}>
            <CloseIcon className={classes.icon} />
          </IconButton>,
        ]}
      />
    );
  }

  componentDidMount() {
    this.autoClose = setTimeout(this.props.onClose, 3000);
  }

  componentWillUnmount() {
    clearTimeout(this.autoClose);
  }
}

Message.propTypes = {
  onClose: PropTypes.func.isRequired,
  message: PropTypes.node.isRequired,
  variant: PropTypes.oneOf(Object.values(MessageTypes)).isRequired,
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(Message);
